import type { SupportedLocale } from "./locales";

const autobus_in_russian = encodeURI("автобус");
const train_in_russian = encodeURI("поезд");
const autobus_company_in_russian = encodeURI("автобусная-компания");

export const template_term_bus: Record<SupportedLocale, string> = {
  en: "bus",
  "en-ca": "bus",
  "en-gb": "bus",
  "en-za": "bus",
  es: "autobus",
  "es-419": "autobus",
  "es-mx": "autobus",
  fr: "bus",
  "fr-ca": "bus",
  de: "bus",
  it: "bus",
  nl: "bus",
  pl: "autobus",
  pt: "onibus",
  "pt-pt": "autocarro",
  ru: autobus_in_russian,
  sv: "buss",
  tr: "otobus",
  zh: "bus"
} as const;

export const template_term_train: Record<SupportedLocale, string> = {
  en: "train",
  "en-ca": "train",
  "en-gb": "train",
  "en-za": "train",
  es: "tren",
  "es-419": "tren",
  "es-mx": "tren",
  fr: "train",
  "fr-ca": "train",
  de: "zug",
  it: "treno",
  nl: "trein",
  pl: "pociag",
  pt: "trem",
  "pt-pt": "trem",
  ru: train_in_russian,
  sv: "vlak",
  tr: "tren",
  zh: "train"
} as const;

export const template_term_bus_company: Record<SupportedLocale, string> = {
  en: "bus-company",
  "en-ca": "bus-company",
  "en-gb": "bus-company",
  "en-za": "bus-company",
  es: "empresa-de-autobuses",
  "es-419": "empresa-de-autobuses",
  "es-mx": "empresa-de-autobuses",
  fr: "compagnie-de-bus",
  "fr-ca": "compagnie-de-bus",
  de: "busunternehmen",
  it: "operatore-di-autobus",
  nl: "busmaatschappij",
  pl: "firma-autobusowa",
  pt: "empresa-de-onibus",
  "pt-pt": "empresa-de-autocarros",
  ru: autobus_company_in_russian,
  sv: "bussbolag",
  tr: "otobus-firmalari",
  zh: "bus-company"
} as const;
